import { jwtDecode } from 'jwt-decode'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { refreshTokenSchema } from '@/features/auth/types/refreshTokenSchema'
import { idTokenSchema } from '@/features/auth/types/idTokenSchema'

import type { AuthResponse } from '@/features/auth/types/authTypes'
import { accessTokenSchema } from '@/features/auth/types/accessTokenSchema'
import { authActions } from '../slices/authSlice'
import { userActions } from '../slices/userSlice'

type AuthActionProps = {
  authResponse: AuthResponse
}

const authAction = createAsyncThunk('authAction', async ({ authResponse }: AuthActionProps, { dispatch }) => {
  const accessTokenData = accessTokenSchema.parse(jwtDecode(authResponse.access_token))
  const refreshTokenData = refreshTokenSchema.parse(jwtDecode(authResponse.refresh_token))
  const idTokenData = idTokenSchema.parse(jwtDecode(authResponse.id_token))
  dispatch(
    authActions.setTokens({
      idToken: authResponse.id_token,
      accessToken: authResponse.access_token,
      accessTokenExpiration: accessTokenData.exp,
      refreshToken: authResponse.refresh_token,
      refreshTokenExpiration: refreshTokenData.exp,
    }),
  )
  dispatch(userActions.setData(idTokenData))
  dispatch(
    userActions.setRoles([
      ...accessTokenData.realm_access.roles,
      ...(accessTokenData.resource_access?.['fvl-frontend']?.roles || []),
    ]),
  )
})

export { authAction }
